"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// Sentry initialization should be imported first!
require("./instrument");
const Sentry = __importStar(require("@sentry/react"));
const React = __importStar(require("react"));
const client_1 = require("react-dom/client");
const ErrorFallback_1 = __importDefault(require("./router/ErrorFallback"));
const GoApp_1 = __importDefault(require("./router/GoApp"));
function renderGoApp() {
    window.event = undefined;
    const container = document.querySelector('#go-app-container');
    if (container) {
        const root = (0, client_1.createRoot)(container);
        root.render((0, jsx_runtime_1.jsx)(Sentry.ErrorBoundary, { beforeCapture: scope => {
                scope.setTag('aplication', 'react');
            }, fallback: ({ error, componentStack, resetError, eventId }) => ((0, jsx_runtime_1.jsx)(ErrorFallback_1.default, { error: error, eventId: eventId, componentStack: componentStack, resetError: resetError })), children: (0, jsx_runtime_1.jsx)(React.StrictMode, { children: (0, jsx_runtime_1.jsx)(GoApp_1.default, {}) }) }));
    }
}
renderGoApp();
